      // ═══════ FAQ ACCORDION ═══════
function toggleFaqs(btn) {
        const item = btn.parentElement;
        const wasOpen = item.classList.contains("open");
        document
          .querySelectorAll(".faq-item")
          .forEach((i) => i.classList.remove("open"));
        if (!wasOpen) item.classList.add("open");
      }

      // ═══════ GALLERY THUMB SWITCH ═══════
      document.querySelectorAll(".gallery-thumb").forEach((thumb, i) => {
        thumb.addEventListener("click", () => {
          document
            .querySelectorAll(".gallery-thumb")
            .forEach((t) => t.classList.remove("active"));
          thumb.classList.add("active");
        });
      });

      // ═══════ STICKY ATC VISIBILITY ═══════
      const atcButton = document.getElementById("atcBtn");
      const stickyBar = document.getElementById("stickyAtc");

      if (window.innerWidth <= 768) {
        const stickyObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              stickyBar.style.display = entry.isIntersecting ? "none" : "flex";
            });
          },
          { threshold: 0 },
        );
        stickyObserver.observe(atcButton);
      }

      // ═══════ SCROLL ANIMATIONS ═══════
      const fadeObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.classList.add("visible");
          });
        },
        { threshold: 0.1, rootMargin: "0px 0px -30px 0px" },
      );

      document
        .querySelectorAll(".fade-up")
        .forEach((el) => fadeObserver.observe(el));

document.addEventListener('DOMContentLoaded', function() {
  const descriptionTab = document.querySelector('#tab-product-description');
  if (!descriptionTab) { return; }
  descriptionTab.classList.add('is-active');
});